import React, { Component } from 'react';
import Train from '../../services/train.js';
import Grid from '../Grid';
import NProgress from 'nprogress'

class UserOverview extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {

      latestArtists: undefined,

      overallTopArtists: undefined,
      overallDiscoveredArtists: undefined,
      semesterlyTopArtists: undefined,
      semesterlyDiscoveredArtists: undefined,
      monthlyTopArtists: undefined,
      monthlyDiscoveredArtists: undefined,
      weeklyTopArtists: undefined,
      weeklyDiscoveredArtists: undefined,

      latestTracks: undefined,

      overallTopTracks: undefined,
      overallLovedTracks: undefined,
      semesterlyTopTracks: undefined,
      semesterlyLovedTracks: undefined,
      monthlyTopTracks: undefined,
      monthlyLovedTracks: undefined,
      weeklyTopTracks: undefined,
      weeklyLovedTracks: undefined
    }
  }

  componentDidMount() {
    this.fetchData(this.userId());
  }

  userId() {
    return this.props.match.params.user;
  }

  fetchData(userId) {

    NProgress.start();

    let topArtistsPromises = ['overall', 'semesterly', 'monthly', 'weekly'].map((period) => {

      return Train.fetchUserTopArtists({user: userId, period: period})
      .then((topArtists) => {
        let state = {};
        state[`${period}TopArtists`] = topArtists[`${period}TopArtists`];
        state[`${period}DiscoveredArtists`] = topArtists[`${period}DiscoveredArtists`]
        this.setState(state);
      });
    });

    let topTracksPromises = ['overall', 'semesterly', 'monthly', 'weekly'].map((period) => {

      return Train.fetchUserTopTracks({user: userId, period: period})
      .then((topTracks) => {
        let state = {};
        state[`${period}TopTracks`] = topTracks[`${period}TopTracks`];
        state[`${period}LovedTracks`] = topTracks[`${period}LovedTracks`]
        this.setState(state);
      });

    });

    let latestArtistPromise = Train.fetchUserLatestArtists({user: userId})
    .then((latestArtists) => {
      this.setState({latestArtists})
    });

    let latestTrackPromise =  Train.fetchUserLatestTracks({user: userId})
    .then((latestTracks) => {
      this.setState({latestTracks})
    });

    let promises = [topArtistsPromises, topTracksPromises, latestArtistPromise, latestTrackPromise]
    .reduce((a, b) => {
      return a.concat(b);
    });

    Promise.all(promises)
    .then(() => {
      NProgress.done();
    });

  }

  topArtists() {
    return {
      overall: this.state.overallTopArtists,
      semesterly: this.state.semesterlyTopArtists,
      monthly: this.state.monthlyTopArtists,
      weekly: this.state.weeklyTopArtists
    };
  }

  discoveredArtists() {
    return {
      overall: this.state.overallDiscoveredArtists,
      semesterly: this.state.semesterlyDiscoveredArtists,
      monthly: this.state.monthlyDiscoveredArtists,
      weekly: this.state.weeklyDiscoveredArtists
    };
  }

  topTracks() {
    return {
      overall: this.state.overallTopTracks,
      semesterly: this.state.semesterlyTopTracks,
      monthly: this.state.monthlyTopTracks,
      weekly: this.state.weeklyTopTracks
    };
  }

  lovedTracks() {
    return {
      overall: this.state.overallLovedTracks,
      semesterly: this.state.semesterlyLovedTracks,
      monthly: this.state.monthlyLovedTracks,
      weekly: this.state.weeklyLovedTracks
    };
  }

 render() {

    return (
      <div>
        <Grid title="Top artists" carousel={true} playable={true} mappable={true} treemappable={true} mapContext="user" mapSearchTerm={this.userId()} mapType="artists" type="artist" hasPeriods={true} elements={this.topArtists()} />
        <Grid title="Discovered artists" carousel={true} playable={true} mappable={true} treemappable={true} mapContext="user" mapSearchTerm={this.userId()} mapType="artists" mapParams={{discovered: true}} type="artist" hasPeriods={true} elements={this.discoveredArtists()} />
        <Grid title="Latest artists" carousel={true} playable={true} mappable={true} treemappable={true} mapContext="user" mapSearchTerm={this.userId()} mapType="artists" mapParams={{sort: 'latest'}} type="artist" elements={this.state.latestArtists} />
        <Grid title="Top tracks" carousel={true} playable={true} treemappable={true} mapContext="user" mapSearchTerm={this.userId()} mapType="tracks" type="track" hasPeriods={true} elements={this.topTracks()} />
        <Grid title="Loved tracks" carousel={true} playable={true} treemappable={true} mapContext="user" mapSearchTerm={this.userId()} mapType="tracks" mapParams={{loved: true}} type="track" hasPeriods={true} elements={this.lovedTracks()} />
        <Grid title="Latest tracks" carousel={true} playable={true} treemappable={true} mapContext="user" mapSearchTerm={this.userId()} mapType="tracks" type="track" elements={this.state.latestTracks} />
      </div>
    ); 

  }
}

export default UserOverview;



// WEBPACK FOOTER //
// ./src/js/components/user/UserOverview.jsx